
























































































































































































import SfFooter from '/storefrontUI/components/components/organisms/SfFooter/SfFooter.vue';
import SfList from '/storefrontUI/components/components/organisms/SfList/SfList.vue';
import SfImage from '/storefrontUI/components/components/atoms/SfImage/SfImage.vue';
import SfButton from '/storefrontUI/components/components/atoms/SfButton/SfButton.vue';
import SfInput from '/storefrontUI/components/components/atoms/SfInput/SfInput.vue';
import SfLink from '/storefrontUI/components/components/atoms/SfLink/SfLink.vue';
import SfMenuItem from '/storefrontUI/components/components/molecules/SfMenuItem/SfMenuItem.vue';
import {defineComponent, onMounted} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import {CacheTagPrefix} from "@vue-storefront/cache";

export default defineComponent({
  components: {
    SfFooter,
    SfList,
    SfImage,
    SfMenuItem,
    SfInput,
    SfButton,
    SfLink,
  },
  setup() {
    return {
      addBasePath,
    };
  },
  data() {
    return {
      categories: [
        {
          label: 'Men',
          link: '/en/men'
        },
        {
          label: 'Women',
          link: '/en/women'
        },
        {
          label: 'Brand',
          link: '/en/brand'
        },
        {
          label: 'Newsletter',
          link: '/en/newsletter'
        }
      ],
      need: [
        {
          label: 'About Us',
          category: '',
          link: '/en/about-us'
        },
        {
          label: 'Contact Us',
          category: '',
          link: '/en/customer-service'
        },
      ],
      ordini: [
        {
          label: 'Returns',
          link: '/en/returns'
        },
        {
          label: 'Payment methods',
          link: '/en/payments'
        },
        {
          label: 'Shipments',
          link: '/en/shipping-2'
        },
        {
          label: 'Support',
          link: '/en/customer-service'
        },
        {
          label: 'Terms & Conditions',
          link: '/en/terms-and-conditions'
        },
      ],
      social: [
        {
          img: 'facebook',
          link: 'https://www.facebook.com/need.it.s.all.you.need/friends_likes/',
        },
        {
          img: 'instagram',
          link: 'https://www.instagram.com/need_italia/',
        }
      ],
      isMobile: false,
      desktopMin: 1024,
    };
  },
});
